import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RewardMap} from "../../services/class-task.service";
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-class-task-rewards',
    templateUrl: './class-task-rewards.component.html',
    styleUrls: ['./class-task-rewards.component.scss'],
    standalone: true,
    imports: [NgIf, MatTooltipModule, FaIconComponent, MatFormFieldModule, MatInputModule, FormsModule]
})
export class ClassTaskRewardsComponent {

  @Input()
  rewards?: RewardMap ;

  @Input()
  editable: boolean = false ;

  @Input()
  inline: boolean = false ;

  @Output()
  rewardsChange: EventEmitter<RewardMap> = new EventEmitter<RewardMap>() ;


  handleRewardsChanged() {
    this.rewardsChange?.emit(this.rewards) ;
  }


}
